module.exports = __webpack_public_path__ + "mongolia.svg?cfb1b2e502923750fc882ca68c01c86a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/mongolia.svg
// module id = 235
// module chunks = 10